import { defaultDisabilityPhysicianFormValues, DisabilityPhysicianFormValues } from "./DisabilityPhysicianFormValues";
import { Frequency } from "../enums/Frequency";

export type PhysicalIllnessOrInjuryDisabilityPhysicianFormValues = DisabilityPhysicianFormValues & {
    restrictedSittingFrequency: Frequency,
    restrictedStandingFrequency: Frequency,
    restrictedWalkingFrequency: Frequency,
    restrictedKeyboardingFrequency: Frequency,
    restrictedFineManipulationFrequency: Frequency,
    restrictedLiftingContinuouslyPounds: string,
    restrictedLiftingFrequentlyPounds: string,
    restrictedLiftingOccasionallyPounds: string,
}

export const defaultPhysicalIllnessOrInjuryDisabilityPhysicianFormValues = {
    ...defaultDisabilityPhysicianFormValues,
    workRelated: '',
    restrictedSittingFrequency: '',
    restrictedStandingFrequency: '',
    restrictedWalkingFrequency: '',
    restrictedKeyboardingFrequency: '',
    restrictedFineManipulationFrequency: '',
    restrictedLiftingContinuouslyPounds: '',
    restrictedLiftingFrequentlyPounds: '',
    restrictedLiftingOccasionallyPounds: '',
}